
import { Component, Vue } from 'vue-property-decorator';
import { User } from '@/utils/models';
import { isAdministrator } from '@/utils/functions';
import LogoHorizontal from '@/components/utils/LogoHorizontal.vue';

type AdminPage = 'log' | 'provider' | 'siteinfo' | 'user?mode=user' | 'user?mode=member' | 'questionnaire' | 'campaign';

@Component({ components: { LogoHorizontal } })
export default class AdminView extends Vue {
  get isTrialSite() {
    return this.$store.state.siteInfo.isDemo;
  }

  navigate(page: AdminPage) {
    const currentPage = this.$route.name as AdminPage;
    if (page !== currentPage) {
      this.$router.push(`/admin/${page}`);
    }
  }

  restart() {
    this.$toast.warning('再起動を実行します。よろしいでしょうか。よろしければこのトーストをクリックしてください。', {
      onClick: () => this.$store.state.dataService?.emitTest(),
    });
  }

  goBack() {
    this.$router.push('/');
  }

  get user(): User {
    return this.$store.state.user;
  }
  get isAdministrator(): boolean {
    return isAdministrator(this.user);
  }
}
